var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownThick = function SvgArrowDownThick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 10,
    fill: "inherit",
    viewBox: "0 0 16.87 9.38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.27.28 8.44 7.11 1.61.28A.93.93 0 0 0 .94 0C.68 0 .45.1.27.28c-.37.37-.37.97 0 1.33l7.5 7.5c.18.18.41.27.67.27.25 0 .49-.1.66-.27l7.49-7.5c.37-.37.37-.96 0-1.33a.97.97 0 0 0-.66-.28c-.25 0-.49.1-.66.28"
  })));
};
export default SvgArrowDownThick;